<template>
	<div class="restricted_table">
		<div class="restricted_message">
			<div class="restricted-message__image">
                <span class="iconify" data-icon="emojione:framed-picture"></span>
			</div>
			<div class="restricted-message__title">
				Oops! Access Denied
			</div>
			<div class="restricted-message__message">
				We're sorry, but this calendar is 
				<span class="restricted-access">{{ accessTitle() }}</span>.
				<span 
				v-if="[3,4].includes(calendarRestricted.visibilityLevelId) 
						&& calendarRestricted.suggestedAction">
					To see the full information please {{ calendarRestricted.suggestedAction }}.
				</span>
			</div>
		</div>
		<b-button type="is-info" expanded
		v-if="suggestedActionTitle()"
		@click="suggestedActionHandler">
			{{ suggestedActionTitle() }}
		</b-button>
	</div>
</template>

<script>
import router from '../../../router';

export default {
	name: 'RestrictedMessage',
	computed: {
		calendarRestricted(){
			return this.$store.getters.calendarRestricted
		}
	},
	methods: {
		accessTitle(){
			let visibilityLevelId = this.calendarRestricted.visibilityLevelId
			if (visibilityLevelId == 1)
				return "private"
			if (visibilityLevelId == 3)
				return "for authorized users only"
			if (visibilityLevelId == 4)
				return "for followed users only"
			return ""
		},
		suggestedActionTitle(){
			let action = this.calendarRestricted.suggestedAction
			if (!action || action == "")
				return null
			return action[0].toUpperCase() + action.slice(1);
		},
		suggestedActionHandler(){
			let action = this.calendarRestricted.suggestedAction
			if (!action || action == "")
				return null
			if (action == "follow") {
				// TODO : make redirect to the follow execution
			} else if (action == "authorize") {
				router.push({name: "auth"})
			}
		},
	},
};
</script>

<style scoped>
.iconify{
	height: 105px;
    width: 170px;
}
.restricted_table{
	height: 100%;
	margin: 30px;
	margin-top: 10px;
	margin-bottom: 80px;
	border-radius: 16px;
	border: 1px solid lightgrey;
	padding: 16px;
	display: flex;
	flex-direction: column;
}

.restricted_message{
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	height: 100%;
	gap: 5px;
}
.restricted-message__title{
	font-size: 18px;
	font-weight: 600;
}

.restricted-message__message{
	font-size: 14px;
	text-align: center;
}

.restricted-access{
	text-decoration: underline;
}
</style>